import { action, computed, observable } from 'mobx'
import { type Id } from '@/infra/id'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { type CreateJobDialogViewModel as JobCreationDialogViewModel } from '@/features/jobs/drafting/components/CreateJobDialog/CreateJobDialogViewModel'

/**
 * Confirms a bulk copy and offers to start editing the copies.
 */
export class BulkCopyJobsSuccessDialogViewModel {
  /**
   * View model for the underlying modal.
   */
  readonly modal = new ModalViewModel()

  @observable.ref private accessor _clonedJobIds: Id[] = []

  constructor(
    private readonly _jobCreationDialogViewModel: JobCreationDialogViewModel,
  ) {}

  /**
   * How many jobs were copied.
   */
  @computed
  get jobCount() {
    return this._clonedJobIds.length
  }

  /**
   * Shows that the given jobs were copied.
   */
  @action.bound
  show(jobIds: Id[]) {
    this._clonedJobIds = jobIds
    this.modal.show()
  }

  /**
   * Starts editing the copies.
   */
  @action.bound
  start() {
    this.modal.close()
    // The dialog renders a failed `edit`.
    this._jobCreationDialogViewModel
      .open(this._clonedJobIds)
      .catch(() => undefined)
  }
}
